import Establecimientos from "./Establecimientos";
export default Establecimientos;